export function copyValueToClipboard(value: string): boolean {
    // The most supported method seems to be running `document.execCommand('copy')` on an element.
    // Since we don't have a text box containing the room ID, let's create a temporary one:

    const input = document.createElement('input');
    input.value = value;
    document.body.appendChild(input);

    input.focus();
    input.select();

    let successful = false;
    try {
        // According to the tutorial, this could fail, e.g. the browser displays a security prompt and the user
        // denies it
        successful = document.execCommand('copy');
    } catch (e) {
        console.error(e);
    } finally {
        input.parentElement?.removeChild(input);
    }

    return successful;
}
